import { Touchable, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef, useMemo } from "react";
import styles from "./ErrorView.module.css";

export interface ErrorViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  retry?: () => void;
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export interface ErrorViewRef {}

export const ErrorView = React.forwardRef(
  ({ retry, message, className, style, ...nativeProps }: ErrorViewProps, forwardRef: ForwardedRef<ErrorViewRef | undefined>) => {
    const classes = useMemo(() => {
      const classes = [styles.container];
      if (className) classes.push(className);
      return classes.join(" ");
    }, [className]);
    return (
      <div {...nativeProps} className={classes} style={style}>
        <div className={styles.message}>{message ?? "Une erreur est apparue."}</div>
        {retry ? (
          <Touchable
            className={styles.retry}
            onPress={() => {
              retry();
            }}
          >
            Réessayer
          </Touchable>
        ) : null}
      </div>
    );
  }
);
